import { FC, HTMLAttributes } from "react";
import { Skeleton } from "@mantine/core";
import clsx from "clsx";

// ----------------------------------------------------------------------------

export type IBlogCardSkeletonProps = HTMLAttributes<HTMLDivElement> & {};

const BlogCardSkeleton: FC<IBlogCardSkeletonProps> = (props) => {
  const { className, ...other } = props;

  return (
    <div className={clsx("h-[619px] bg-white", className)} {...other}>
      {/* Image Skeleton */}
      <Skeleton
        height="100%"
        width="100%"
        className="mb-4 h-[285px] md:h-[184px] lg:h-[240px] xl:h-[330px]"
      />

      {/* Text Skeletons */}
      <div>
        <Skeleton height={20} width="40%" className="mb-2" />
        <Skeleton height={16} width="100%" className="mb-2" />
        <Skeleton height={16} width="100%" className="mb-4" />
        <Skeleton height={16} width="70%" className="mb-4" />
      </div>

      {/* Author Details */}
      <div className="mt-6 flex items-center">
        <Skeleton height={32} width={32} circle className="mr-2 rounded-full" />
        <Skeleton height={16} width="50%" className="" />
      </div>

      {/* Button Skeleton */}
      <Skeleton
        height={40}
        width="40%"
        className="mb-2 mt-7 w-1/3 rounded-none lg:w-2/5"
      />
    </div>
  );
};

export default BlogCardSkeleton;
